class ScrollingSection {
  constructor(root) {
    this.root = root;
    this.buttonsContainer = this.root.querySelector('.ScrollingSection-buttons');

    this.buttonsContainer.addEventListener('click', this.onButtonClick.bind(this));
  }

  onButtonClick(e) {
    e.preventDefault();

    if (e.target.classList.contains('Button')) {
      const card = this.root.querySelector(`#${e.target.dataset.section}`);
      const y = card.getBoundingClientRect().top + window.scrollY - 200;

      window.scrollTo({
        top: y,
        behavior: 'smooth',
      });
    }
  }
}

[].forEach.call(document.querySelectorAll('.ScrollingSection'), (node) => {
  new ScrollingSection(node);
});
